import { Component, Input, inject, signal } from '@angular/core';
import { AnalyticsExportService } from '@shared/services/api/analytics-export.service';
import { finalize } from 'rxjs/operators';
import { AnalyticsQueryResult, AreaSaturation, TrayStatusRow, VolumeSaturation } from '@shared/models/analytics';

@Component({
  selector: 'app-warehouse-status-view',
  templateUrl: './warehouse-status-view.component.html',
  styleUrl: './warehouse-status-view.component.scss'
})
export class WarehouseStatusView {
  @Input() filters?: Record<string, any[]> | null = null;
  private readonly exportService = inject(AnalyticsExportService);

  isExportingMostRequested = signal(false);
  isExportingLeastRequested = signal(false);

  formatAreaSaturation(data: AreaSaturation[]): string[] {
    if (!data || data.length === 0) {
      return [''];
    }

    const { total_area, occupied_area, saturation_percentage } = data[0];

    const rows = [
      `OCCUPIED AREA: ${occupied_area}`,
      `TOTAL AREA: ${total_area}`,
      `SATURATION: ${Number(saturation_percentage).toFixed(2)}%`
    ];

    return rows;
  }

  formatVolumeSaturation(data: VolumeSaturation[]): string[] {
    if (!data || data.length === 0) {
      return [''];
    }

    const { total_volume, occupied_volume, saturation_percentage } = data[0];

    const rows = [
      `OCCUPIED VOLUME: ${occupied_volume}`,
      `TOTAL VOLUME: ${total_volume}`,
      `SATURATION: ${Number(saturation_percentage).toFixed(2)}%`
    ];

    return rows;
  }

  trayValueForStatus(
    result: AnalyticsQueryResult<TrayStatusRow> | null | undefined,
    status = 'total',
    field: keyof TrayStatusRow = 'value'
  ): string | number {
    if (!result || !result.rows || !result.rows.length) {
      return '';
    }

    const found = result.rows.find((r) => r && r.status === status);
    if (!found) {
      return '';
    }

    return found[field] != null ? (found[field] as string | number) : '';
  }

  onExportFormatSelected(format: 'csv' | 'pdf', query: string): void {
    const isMostRequested = query === 'ten-most-requested-articles';
    const isLeastRequested = query === 'ten-least-requested-articles';

    if (isMostRequested) {
      this.isExportingMostRequested.set(true);
    } else if (isLeastRequested) {
      this.isExportingLeastRequested.set(true);
    }

    this.exportService
      .export(query, this.filters ?? null, format)
      .pipe(
        finalize(() => {
          if (isMostRequested) {
            this.isExportingMostRequested.set(false);
          } else if (isLeastRequested) {
            this.isExportingLeastRequested.set(false);
          }
        })
      )
      .subscribe({
        error: (err: any) => {
          console.error(`Error exporting ${format.toUpperCase()}`, err);
        }
      });
  }
}
